var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3125 5.25C5.3125 4.41457 5.64832 3.61335 6.2461 3.02261C6.84387 2.43187 7.65462 2.1 8.5 2.1C9.34538 2.1 10.1561 2.43187 10.7539 3.02261C11.3517 3.61335 11.6875 4.41457 11.6875 5.25V7.35H5.3125V5.25ZM3.1875 7.35V5.25C3.1875 3.85761 3.74721 2.52226 4.74349 1.53769C5.73978 0.553123 7.09104 0 8.5 0C9.90896 0 11.2602 0.553123 12.2565 1.53769C13.2528 2.52226 13.8125 3.85761 13.8125 5.25V7.35H15.9375C16.2193 7.35 16.4895 7.46062 16.6888 7.65754C16.8881 7.85445 17 8.12152 17 8.4V17.85C17 18.6854 16.6642 19.4866 16.0664 20.0774C15.4686 20.6681 14.6579 21 13.8125 21H3.1875C2.34212 21 1.53137 20.6681 0.933597 20.0774C0.335825 19.4866 0 18.6854 0 17.85V8.4C0 8.12152 0.111942 7.85445 0.311199 7.65754C0.510457 7.46062 0.780707 7.35 1.0625 7.35H3.1875ZM9.5625 14.175C9.5625 13.7573 9.73041 13.3567 10.0293 13.0613C10.3282 12.7659 10.7336 12.6 11.1562 12.6H11.1669C11.5896 12.6 11.9949 12.7659 12.2938 13.0613C12.5927 13.3567 12.7606 13.7573 12.7606 14.175V14.1855C12.7606 14.6032 12.5927 15.0038 12.2938 15.2992C11.9949 15.5946 11.5896 15.7605 11.1669 15.7605H11.1562C10.7336 15.7605 10.3282 15.5946 10.0293 15.2992C9.73041 15.0038 9.5625 14.6032 9.5625 14.1855V14.175Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lockIcon.a424463d0f8bfc8be8e6c8ac4c4409f8.svg";
export { ForwardRef as ReactComponent };